const initialState = { data: [], loading: true };

export const GetAllStockReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_all_stock":
      return {
        data: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
